const globalVariablesPlugin = {
    install(Vue) {
      Vue.prototype.$colors = {
        primary: '#00BFFF',
        secondary: '#00FF00',
        
        // 其他颜色值
      };
    },
  };
  
  export default globalVariablesPlugin;
  


// WEBPACK FOOTER //
// ./src/plugins/globalVariables.js